const DEFAULT_COLUMNS = [
  { key: 'Spadenr', default: '', name: 'Spadenr', sortKey: 'Spader.Spadenr', class: 'sorttable_numeric', readonly: true, selected: true },
  { key: 'Kundenr', default: '-', name: 'Kundenr #', sortKey: 'Spader.Kundenr', class: 'sorttable_numeric', selected: true },
  { key: 'kunde.parsed_name', default: '-', name: 'Kunde', sortKey: '', class: 'unsortable', selected: true },
  { key: 'kunde.full_address_lev', default: '-', name: 'Adresse', sortKey: '', class: 'unsortable', selected: true },
  { key: 'kunde.Mobil', default: '-', name: 'Mobil', sortKey: '', class: 'unsortable', selected: true }
]

const state = {
}

const getters = {
  columns: state => {
    return DEFAULT_COLUMNS
  }
}

const actions = {
}

const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/spader.js